import React from "react";
import { Instagram as IgIcon } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { S } from "../../data/strings";
import { GALLERY, CONTACT } from "../../data/content";
import { SectionHead } from "./Ornament";
import { EASE } from "../../lib/motion";

export const InstagramGallery = () => {
  const { t } = useLang();
  return (
    <section data-testid="instagram-section" className="bg-ivory grain relative py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <SectionHead overline={S.gallery.overline} heading={S.gallery.heading} />
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
          {GALLERY.map((img, i) => (
            <motion.a
              key={i}
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-tile-${i}`}
              className="group relative overflow-hidden aspect-square rounded-md"
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.6, ease: EASE, delay: (i % 4) * 0.06 }}
            >
              <img src={img} alt="Nikunj Ittar Wale on Instagram" loading="lazy" className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
              <div className="absolute inset-0 bg-burgundy/0 group-hover:bg-burgundy/50 transition-colors duration-500 flex items-center justify-center">
                <IgIcon className="w-6 h-6 text-goldlight opacity-0 group-hover:opacity-100 scale-75 group-hover:scale-100 transition-all duration-500" />
              </div>
            </motion.a>
          ))}
        </div>
        <div className="mt-12 text-center">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-cta"
            className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-7 py-3.5 text-sm font-medium text-maroon hover:bg-maroon hover:text-ivory hover:border-maroon transition-all duration-300"
          >
            <IgIcon className="w-4 h-4" /> {t(S.gallery.cta)}
          </a>
        </div>
      </div>
    </section>
  );
};
